module.exports = __webpack_public_path__ + "img/sample.2077f874.jpg";